module.exports = __webpack_public_path__ + "img/agente_omni_busca.6d234245.png";